import React, { useContext, useMemo } from 'react';
import { CardData } from 'types/story';
import { Context } from 'client/components/common/SelectionHint/SelectionHintContext';
import { TRAVERSE_TREE_TARGETS } from 'client/components/common/BuildingBlocks/utils/common';
import { StoryFacade } from 'common/utils/facades/story-facade';
import Card from './Card';

type Props = {
	data: CardData;
	story: StoryFacade;
};

const CardEditable: React.FC<Props> = props => {
	const ctx = useContext(Context);
	const treeOptions = useMemo(() => {
		if (!ctx.treeOptions) {
			return null;
		}

		return {
			target: TRAVERSE_TREE_TARGETS.EDITOR,
			isCardTree: true,
			onMouseDown: ctx.treeOptions.onMouseDown,
			onFocus: ctx.treeOptions.onFocus,
			onMouseEnter: ctx.treeOptions.onMouseEnter,
			onMouseLeave: ctx.treeOptions.onMouseLeave,
			onMouseDownCapture: ctx.treeOptions.onMouseDownCapture,
			onDoubleClickCapture: ctx.treeOptions.onDoubleClickCapture,
		} as const;
	}, [ctx]);

	if (!treeOptions) return null;

	return <Card card={props.data} treeOptions={treeOptions} isEditor story={props.story} />;
};

export default CardEditable;
